import { configureStore } from "@reduxjs/toolkit";
import frameReducer from "./frame";

export default configureStore({
    reducer: {frame: frameReducer,}
});
